import { z } from 'zod/v4';

import { endpoint } from '../http/endpoint';
import { AssemblyIdRuntype, PcbIdRuntype } from '../idTypes';
import {
    PCBSpecificationTemplatePostRuntype,
    PCBSpecificationTemplatePreferencesPostRuntype,
    PCBSpecificationTemplatePreferencesRuntype,
    PCBSpecificationTemplateRuntype,
} from './pcbSpecificationTemplateBackendTypes';

export const pcbSpecificationTemplateEndpoints = {
    'GET /pcb-specification-templates': endpoint({
        description: 'Get all PCB specification templates',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.array(PCBSpecificationTemplateRuntype),
    }),

    'POST /pcb-specification-templates': endpoint({
        description: 'Create a new PCB specification template',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: PCBSpecificationTemplatePostRuntype,
        responseBody: PCBSpecificationTemplateRuntype,
        invalidates: ['GET /pcb-specification-templates'],
    }),

    'GET /pcb-specification-templates/:id': endpoint({
        description: 'Get a PCB specification template by id',
        pathParams: z.object({ id: z.string() }),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: PCBSpecificationTemplateRuntype,
    }),

    'PATCH /pcb-specification-templates/:id': endpoint({
        description: 'Update a PCB specification template',
        pathParams: z.object({ id: z.string() }),
        queryParams: z.undefined(),
        requestBody: PCBSpecificationTemplatePostRuntype.extend({ id: z.string() }),
        responseBody: PCBSpecificationTemplateRuntype,
        invalidates: ['GET /pcb-specification-templates'],
    }),

    'DELETE /pcb-specification-templates/:id': endpoint({
        description: 'Delete a PCB specification template',
        pathParams: z.object({ id: z.string() }),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.object({ deleted: z.number() }),
        invalidates: ['GET /pcb-specification-templates'],
    }),

    'GET /pcb-specification-preferences/assemblies/:assemblyId/pcb/:pcbId': endpoint({
        description:
            'Get the PCB specification preferences (always returns preferences; creates with all fields visible if none exist)',
        pathParams: z.object({ assemblyId: AssemblyIdRuntype, pcbId: PcbIdRuntype }),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: PCBSpecificationTemplatePreferencesRuntype,
    }),

    'PUT /pcb-specification-preferences/assemblies/:assemblyId/pcb/:pcbId': endpoint({
        description: 'Create a new PCB specification preference',
        pathParams: z.object({ assemblyId: AssemblyIdRuntype, pcbId: PcbIdRuntype }),
        queryParams: z.undefined(),
        requestBody: PCBSpecificationTemplatePreferencesPostRuntype,
        responseBody: PCBSpecificationTemplatePreferencesRuntype,
        invalidates: ['GET /pcb-specification-preferences/assemblies/:assemblyId/pcb/:pcbId'],
    }),

    'DELETE /pcb-specification-preferences/assemblies/:assemblyId/pcb/:pcbId': endpoint({
        description: 'Delete a PCB specification preference',
        pathParams: z.object({ assemblyId: AssemblyIdRuntype, pcbId: PcbIdRuntype }),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.object({ deleted: z.number() }),
    }),
};
